import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, withModifiers as _withModifiers, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-bb790472"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "pa-3 pa-sm-2 pa-md-2 components--buy-form",
  ref: "formDiv"
}
const _hoisted_2 = { class: "mb-6 mt-6" }
const _hoisted_3 = { class: "d-flex align-center justify-space-between mb-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mew-heading-4 textDark--text" }, "I want to Buy", -1))
const _hoisted_5 = {
  key: 0,
  class: "ml-2 d-flex align-center"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "h3 font-weight-regular mr-1" }, "Loading", -1))
const _hoisted_7 = { class: "d-flex flex-column mt-2" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "mt-2 mx-4" }
const _hoisted_10 = { class: "mb-6" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mew-heading-4 textDark--text mb-3" }, "I am spending", -1))
const _hoisted_12 = { class: "d-flex mt-2" }
const _hoisted_13 = { class: "currency-container" }
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = { class: "d-flex align-center" }
const _hoisted_16 = { class: "currency-container mr-1 ml-3" }
const _hoisted_17 = ["src", "alt"]
const _hoisted_18 = { class: "text-capitalize ml-2 my-2 d-flex flex-column" }
const _hoisted_19 = {
  key: 0,
  class: "mt-2 mx-4"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mew-heading-4 textDark--text mb-3" }, " Where should we send your crypto? ", -1))
const _hoisted_21 = {
  key: 0,
  class: "text-bolder text-error mew-heading-4 text-center"
}
const _hoisted_22 = { class: "text-gray" }
const _hoisted_23 = {
  key: 1,
  class: "pt-2 text-center"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white font-weight-bold" }, "Preview Quotes", -1))
const _hoisted_25 = {
  key: 2,
  class: "text-center py-5"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-center font-weight-bold mt-3",
  style: {"line-height":"1.4rem"}
}, " Processing purchase.... ", -1))

import {
  computed,
  reactive,
  watch,
  onMounted,
  onUnmounted,
  ref,
  Ref,
} from "vue";
import BigNumber from "bignumber.js";
import { storeToRefs } from "pinia";
import { currencySymbols } from "./handler/prices";
import { isObject, isNumber, isString, isEmpty, debounce } from "lodash";
import addressValidator from "@/helpers/addressValidator";
import { sha3 } from "web3-utils";

import { useGlobalStore } from "@/plugins/globalStore";

import MewAddressSelect from "../MewAddressSelect/MewAddressSelect.vue";
import { Network } from "./network/types";
import api from "./handler/api";
import enkryptNetworkMap from "@/helpers/enkryptNetworkMap";

const defaultFiatValue = "300";

// nonreactive

export default /*#__PURE__*/_defineComponent({
  __name: 'BuyForm',
  props: {
  heldAddress: {
    type: String,
    default: "",
  },
},
  emits: ["addressInput"],
  setup(__props, { emit: __emit }) {

const props = __props;

const store = useGlobalStore();
const {
  selectedFiat,
  selectedCrypto,
  selectedNetwork,
  buyFiats,
  buyNetworks,
  allCryptos,
  conversionRates,
  urlParamsLoaded,
} = storeToRefs(store);
const {
  setNetworks,
  setSelectedCrypto,
  setSelectedNetwork,
  setProviders,
  setBuyProviders,
  toggleTokenModal,
  setSelectedFiat,
  toggleBuyProviders,
  setUrlParamsLoaded,
} = store;

// data
const rules = [
  (e: any) => {
    if (isString(e) && e?.length >= 1) return true;
    if (!isNumber(e)) return "Must be a valid number";
    return true;
  },
];

const emit = __emit;

// reactive
// eslint-disable-next-line no-undef
let priceTimer: NodeJS.Timer;

const fiatFilter: Ref<string> = ref("");
const fiatItems: Ref<string[]> = ref([]);
const filteredFiatItems: Ref<string[]> = ref([]);
const price = ref("0");
const form = reactive({
  fiatAmount: defaultFiatValue,
  fiatSelected: "USD",
  cryptoAmount: "0",
  cryptoSelected: "ETH",
  address: "",
  validAddress: false,
  addressErrorMsg: "",
  reCaptchaToken: "",
  addressError: false,
  quoteError: "",
});
const loading = reactive({
  data: false,
  showAlert: false,
  processingBuyForm: false,
  alertMessage: "",
});

const addressSelect = ref(null);

onMounted(async () => {
  if (addressSelect.value) {
    addressSelect.value.locAddress = props.heldAddress;
    addressSelect.value.onInputChange(props.heldAddress);
  }
  // addressInput(props.heldAddress, "");
  // Get crypto Data
  await getPrices();
  if (!isEmpty(selectedFiat.value)) {
    form.cryptoSelected = selectedCrypto.value.symbol;
    form.fiatSelected = selectedFiat.value.name;
    form.fiatAmount = "300";
  }
  // Load URL parameter value and verify crypto address
  loadUrlParameters();
  priceTimer = setInterval(getPrices, 1000 * 60);
  fiatToCrypto();
});

onUnmounted(async () => {
  clearInterval(priceTimer);
});

// watchers
watch(
  () => form.cryptoSelected,
  () => {
    verifyAddress();
    fiatToCrypto();
    minMaxError();
  }
);

watch(
  () => form.fiatSelected,
  (newVal, oldVal) => {
    if (oldVal === "USD") {
      form.fiatAmount = BigNumber(form.fiatAmount)
        .times(conversionRates.value.get(newVal))
        .toFixed(2);
    } else {
      const backToUsd = BigNumber(form.fiatAmount)
        .div(conversionRates.value.get(oldVal))
        .toFixed(2);
      form.fiatAmount = BigNumber(backToUsd)
        .times(conversionRates.value.get(newVal))
        .toFixed(2);
    }
    verifyAddress();
    cryptoToFiat();
    minMaxError();

    buyFiats.value.forEach((value, key) => {
      if (key === newVal) {
        setSelectedFiat({
          name: key,
          value: key,
          img: require(`@/assets/images/fiat/${key}.svg`),
        });
      }
    });
  }
);

watch(
  () => form.fiatAmount,
  () => {
    if (!loading.data) {
      minMaxError();
    }
  }
);
watch(
  () => form.cryptoAmount,
  () => {
    if (!loading.data) {
      minMaxError();
    }
  }
);

// computed
const isValidForm = computed(() => {
  return (
    form.fiatSelected &&
    form.cryptoSelected &&
    form.address &&
    !form.addressError &&
    form.addressErrorMsg === "" &&
    loading.alertMessage === "" &&
    form.validAddress &&
    form.quoteError === ""
  );
});

const addressValid = computed(() => {
  return addressValidator(form.address, selectedNetwork.value.name);
});

const limits = computed(() => {
  const lim = buyFiats.value.get(form.fiatSelected)?.limits || {
    min: 0,
    max: 0,
  };

  return lim;
});

const min = computed(() => {
  return limits.value.min;
});
const max = computed(() => {
  return limits.value.max;
});

// methods
const getIcon = (currency: string, isFiat = true) => {
  return require(`@/assets/images/${
    isFiat ? "fiat" : "crypto"
  }/${currency}.svg`);
};

const selectCurrency = (currency: string) => {
  form.fiatSelected = currency;
  setSelectedFiat({
    name: currency,
    value: currency,
    img: require(`@/assets/images/fiat/${currency}.svg`),
  });
};

const updateFiatFilter = (value: string) => {
  if (value === "") {
    fiatFilter.value = value;
    filteredFiatItems.value = fiatItems.value;
  } else {
    const shallowArrayCopy = new Array(...fiatItems.value);
    fiatFilter.value = value;
    filteredFiatItems.value = shallowArrayCopy.filter((item) =>
      item.toLowerCase().includes(fiatFilter.value.toLowerCase())
    );
  }
};

const loadUrlParameters = () => {
  if (urlParamsLoaded.value) return;
  const queryString = window.location.search;
  if (queryString) {
    const urlParams = new URLSearchParams(queryString);
    const queryFiat = urlParams.get("fiat");
    const queryCrypto = urlParams.get("crypto");
    const queryTo = urlParams.get("to");
    const queryNetwork = urlParams.get("network");
    const locParsedNetwork = enkryptNetworkMap(queryNetwork || "ETH")
      ? enkryptNetworkMap(queryNetwork as string)
      : "ETH";
    // validate queries
    const isSupportedCrypto = allCryptos.value.find((cItem) => {
      if (
        cItem.symbol.toLowerCase() === queryCrypto?.toLowerCase() &&
        locParsedNetwork?.toLowerCase() === cItem.network.toLowerCase()
      ) {
        return queryCrypto;
      }
    });

    const supportedNetwork = buyNetworks.value.find((network: Network) => {
      if (network.name.toLowerCase() === locParsedNetwork?.toLowerCase()) {
        return locParsedNetwork;
      }
    });

    const isSupportedFiat = buyFiats.value.get(
      queryFiat?.toUpperCase() || "USD"
    );

    form.fiatSelected = isSupportedFiat?.fiat_currency || "USD";
    form.cryptoSelected = isSupportedCrypto?.symbol || "ETH";

    if (isSupportedCrypto && supportedNetwork) {
      setSelectedCrypto(isSupportedCrypto);
      setSelectedNetwork(supportedNetwork);
    }
    if (isSupportedFiat) {
      setSelectedFiat({
        name: isSupportedFiat.fiat_currency,
        value: isSupportedFiat.fiat_currency,
        img: require(`@/assets/images/fiat/${isSupportedFiat.fiat_currency}.svg`),
      });
    }
    if (queryTo) {
      form.address = queryTo ? queryTo : "";
      verifyAddress();
    }
  }
  setUrlParamsLoaded();
};

const errorHandler = (e: any): void => {
  const value = BigNumber(form.fiatAmount).gt(BigNumber(0));
  if (value) {
    const isErrorObj = isObject(e.response.data.error);
    if (isErrorObj) {
      // eslint-disable-next-line
      const hasErr = e.response.data.error.hasOwnProperty("errors");
      if (hasErr) {
        loading.alertMessage = e.response.data.error.errors[0].message;
      }
    } else {
      loading.alertMessage = e.response.data.error;
    }
  }
};

const addressInput = (value: string, isResolved: string): void => {
  form.address = value;
  emit("addressInput", isResolved ? isResolved : value);
  verifyAddress();
};

const verifyAddress = async (): Promise<void> => {
  const valid = addressValid.value;
  if (valid) {
    const { isRestricted } = await fetch(
      `https://partners.mewapi.io/o/walletscreen?address=${form.address}`
    ).then((res) => res.json());
    if (isRestricted) {
      form.addressErrorMsg = `Please provide a valid ${form.cryptoSelected} address`;
      form.addressError = true;
      form.validAddress = false;
      return;
    }

    form.addressErrorMsg = "";
    form.addressError = false;
    form.validAddress = true;
  } else {
    if (!form.address) {
      form.addressErrorMsg = "";
      form.validAddress = false;
    } else {
      form.addressErrorMsg = `Please provide a valid ${form.cryptoSelected} address`;
      form.validAddress = false;
    }
  }
};

const minMaxError = () => {
  const amount = new BigNumber(form.fiatAmount);
  const valid =
    amount.gte(new BigNumber(min.value)) &&
    amount.lte(new BigNumber(max.value));

  if (!valid) {
    const symbol = currencySymbols[form.fiatSelected]
      ? currencySymbols[form.fiatSelected]
      : "";
    loading.showAlert = true;
    loading.alertMessage = `Fiat price must be between ${symbol}${min.value} and ${symbol}${max.value}`;
    return;
  }
  loading.showAlert = false;
  loading.alertMessage = "";
};

const getPrices = async () => {
  try {
    loading.data = true;
    const data = await fetch(
      `${api.endpoint}/v5/purchase/info?includeMarketData=true`
    );
    const response = await data.json();
    const { msg } = response;
    if (msg) {
      form.quoteError = msg;
      loading.data = false;
      return;
    }
    const { assets, providers } = response;
    setNetworks(assets);
    setProviders(providers);
    fiatItems.value = Array.from(buyFiats.value.keys());
    filteredFiatItems.value = Array.from(fiatItems.value);
    loading.data = false;
  } catch (e: any) {
    loading.data = false;
    errorHandler(e);
  }
};

const fiatToCrypto = debounce(() => {
  if (!isNaN(parseInt(form.fiatAmount))) {
    cryptoToFiat();
  } else {
    loading.alertMessage = "Please provide a valid fiat amount";
  }
}, 500);

const cryptoToFiat = async () => {
  try {
    loading.data = true;
    form.quoteError = "";
    const priceFetch = await fetch(
      `${api.endpoint}/v5/purchase/quote?fiatCurrency=${selectedFiat.value.name}&amount=${form.fiatAmount}&cryptoCurrency=${selectedCrypto.value.symbol}&chain=${selectedNetwork.value.name}`
    );
    const priceResponse = await priceFetch.json();

    if (priceResponse.msg) {
      form.quoteError = priceResponse.msg;
      loading.data = false;
      return;
    }
    form.cryptoAmount = priceResponse[0].crypto_amount;
    price.value = priceResponse[0].crypto_price;
    loading.data = false;
  } catch (e) {
    errorHandler(e);
    loading.data = false;
  }
};

const submitForm = async (): Promise<void> => {
  try {
    loading.data = true;
    const { fiatAmount, address } = form;
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const platform = urlParams.get("platform") || "web";
    const id = sha3(address)?.substring(0, 42);
    const providersFetch = await fetch(
      `${api.endpoint}/v5/purchase/buy?id=${id}&address=${address}&fiatCurrency=${selectedFiat.value.name}&amount=${fiatAmount}&cryptoCurrency=${selectedCrypto.value.symbol}&chain=${selectedNetwork.value.name}&iso=US&platform=${platform}`
    );
    const providers = await providersFetch.json();
    if (providers.msg || providers.error) {
      loading.data = false;
      loading.alertMessage = providers.msg || providers.error;
      return;
    }
    setBuyProviders(providers);
    toggleBuyProviders();
    loading.data = false;
  } catch (e) {
    loading.data = false;
    errorHandler(e);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (loading.data)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_v_progress_circular, {
                size: 11,
                width: 2,
                indeterminate: ""
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_v_btn, {
          rounded: "right",
          variant: "outlined",
          class: "no-left-border full-button",
          "append-icon": "mdi-menu-down",
          disabled: loading.data,
          onClick: _unref(toggleTokenModal)
        }, {
          prepend: _withCtx(() => [
            _createElementVNode("img", {
              class: "currency-icon mr-1 padding--2",
              src: _unref(selectedCrypto).img,
              alt: form.cryptoSelected,
              width: "25px",
              height: "25px"
            }, null, 8, _hoisted_8)
          ]),
          append: _withCtx(() => [
            _createVNode(_component_v_icon, {
              color: "grey-2",
              size: "large"
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_unref(selectedCrypto).symbol) + " - " + _toDisplayString(_unref(selectedCrypto).name), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createElementVNode("div", _hoisted_9, "Network: " + _toDisplayString(_unref(selectedNetwork).name_long), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_v_text_field, {
          class: _normalizeClass([
            loading.alertMessage ? '' : 'error-state',
            'no-right-border',
          ]),
          onInput: _unref(fiatToCrypto),
          modelValue: form.fiatAmount,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.fiatAmount) = $event)),
          modelModifiers: { number: true },
          required: "",
          variant: "outlined",
          "error-messages": loading.alertMessage,
          disabled: loading.data,
          rules: rules
        }, null, 8, ["class", "onInput", "modelValue", "error-messages", "disabled"]),
        _createVNode(_component_v_select, {
          style: {"max-width":"130px","height":"56px !important"},
          class: "rounded-right no-left-border buy-input",
          modelValue: form.fiatSelected,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.fiatSelected) = $event)),
          items: filteredFiatItems.value,
          disabled: loading.data,
          "menu-props": { closeOnContentClick: true },
          "list-props": { density: 'compact' },
          "base-color": "primary",
          "return-object": "",
          variant: "outlined"
        }, {
          "prepend-inner": _withCtx(() => [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("img", {
                src: _unref(selectedFiat).img,
                alt: form.fiatSelected,
                width: "30px",
                height: "30px"
              }, null, 8, _hoisted_14)
            ])
          ]),
          "prepend-item": _withCtx(() => [
            _createVNode(_component_v_text_field, {
              modelValue: fiatFilter.value,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = ($event: any) => ((fiatFilter).value = $event)),
                updateFiatFilter
              ],
              variant: "outlined",
              class: "px-2",
              "prepend-inner-icon": "mdi-magnify",
              autofocus: true,
              density: "compact",
              placeholder: "Search",
              onClick: _cache[2] || (_cache[2] = _withModifiers((e) => e.preventDefault(), ["stop"]))
            }, null, 8, ["modelValue"])
          ]),
          item: _withCtx(({ item, props }) => [
            _createVNode(_component_v_list_item, _mergeProps(props, {
              class: "d-flex align-center justify-space-between full-width cursor-pointer",
              onClick: ($event: any) => (selectCurrency(item.value))
            }), {
              title: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("img", {
                      src: getIcon(item.value),
                      alt: item.value,
                      width: "30px",
                      height: "30px"
                    }, null, 8, _hoisted_17)
                  ]),
                  _createElementVNode("span", _hoisted_18, _toDisplayString(item.value), 1)
                ])
              ]),
              _: 2
            }, 1040, ["onClick"])
          ]),
          _: 1
        }, 8, ["modelValue", "items", "disabled"])
      ]),
      (!loading.alertMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, " ~" + _toDisplayString(form.cryptoAmount) + " " + _toDisplayString(form.cryptoSelected), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      _hoisted_20,
      _createVNode(MewAddressSelect, {
        ref_key: "addressSelect",
        ref: addressSelect,
        modelValue: form.address,
        "error-messages": form.addressErrorMsg,
        autofocus: false,
        "is-valid-address": addressValid.value,
        placeholder: "Enter Crypto Address",
        network: _unref(selectedNetwork),
        onKeyup: verifyAddress,
        onChanged: addressInput
      }, null, 8, ["modelValue", "error-messages", "is-valid-address", "network"])
    ]),
    (form.quoteError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createElementVNode("span", _hoisted_22, _toDisplayString(form.quoteError), 1)
        ]))
      : _createCommentVNode("", true),
    (!loading.processingBuyForm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", null, [
            _createVNode(_component_v_btn, {
              flat: "",
              rounded: "pill",
              disabled: !isValidForm.value,
              "min-height": "60px",
              width: "360px",
              onClick: submitForm,
              class: "buy-button"
            }, {
              default: _withCtx(() => [
                _hoisted_24
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _createVNode(_component_v_progress_circular, {
            size: 70,
            width: 7,
            indeterminate: "",
            color: "#05c0a5"
          }),
          _hoisted_26
        ]))
  ], 512))
}
}

})